/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetReportTab200ResponseShipment
 */
export interface GetReportTab200ResponseShipment {
    /**
     * 
     * @type {string}
     * @memberof GetReportTab200ResponseShipment
     */
    provider: string;
    /**
     * 
     * @type {Date}
     * @memberof GetReportTab200ResponseShipment
     */
    dateTime?: Date;
}

/**
 * Check if a given object implements the GetReportTab200ResponseShipment interface.
 */
export function instanceOfGetReportTab200ResponseShipment(value: object): value is GetReportTab200ResponseShipment {
    if (!('provider' in value) || value['provider'] === undefined) return false;
    return true;
}

export function GetReportTab200ResponseShipmentFromJSON(json: any): GetReportTab200ResponseShipment {
    return GetReportTab200ResponseShipmentFromJSONTyped(json, false);
}

export function GetReportTab200ResponseShipmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetReportTab200ResponseShipment {
    if (json == null) {
        return json;
    }
    return {
        
        'provider': json['provider'],
        'dateTime': json['dateTime'] == null ? undefined : (new Date(json['dateTime'])),
    };
}

export function GetReportTab200ResponseShipmentToJSON(json: any): GetReportTab200ResponseShipment {
    return GetReportTab200ResponseShipmentToJSONTyped(json, false);
}

export function GetReportTab200ResponseShipmentToJSONTyped(value?: GetReportTab200ResponseShipment | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'provider': value['provider'],
        'dateTime': value['dateTime'] == null ? undefined : ((value['dateTime']).toISOString()),
    };
}

